import i18n from 'i18next'

/**
 * Converts a short language code (as stored in i18n) to a full locale code
 * suitable for Intl.NumberFormat / Intl.DateTimeFormat.
 * English maps to en-US; all others fold to lang-LANG (e.g. de → de-DE).
 */
export function getLocaleFromLanguage(languageCode: string | null): string {
  if (!languageCode) return 'en-US'
  if (languageCode.includes('-')) return languageCode
  const lang = languageCode.toLowerCase()
  if (lang === 'en') return 'en-US'
  return `${lang}-${lang.toUpperCase()}`
}

/**
 * Returns the current UI locale derived from react-i18next.
 * Use this instead of Scrivito's currentLanguage() — the language switcher
 * calls i18n.changeLanguage(), not anything in Scrivito.
 */
export function getCurrentLocale(): string {
  return getLocaleFromLanguage(i18n.resolvedLanguage ?? null)
}
